import { preloadContentPrerequisites } from '@confluence/content-prerequisites/entry-points/preloadContentPrerequisites.ts';
import { preloadContentTypesHeader } from '@confluence/content-types-header/entry-points/preloadContentTypesHeader.js';
import { fg } from '@confluence/feature-gating';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const preloadAttachmentsPageRoute = async (
	match: RouteMatch,
): Promise<void | any[] | Error[]> => {
	const tasks: Promise<any>[] = [];

	const { contentId, spaceKey } = match.params;

	// Since this query is not called in ContentPrerequisites when contentId is
	// missing, we should follow the same reasoning and skip preload when content is
	// missing.
	if (contentId) {
		tasks.push(preloadContentPrerequisites(contentId, spaceKey));
	}

	if (fg('confluence_frontend_content_wrapper')) {
		tasks.push(preloadContentTypesHeader(contentId, fg('confluence_frontend_content_wrapper')));
	}

	return waitForAllReturnWhenError(tasks);
};
